import React, { FC } from 'react'
import { Button, ButtonProps, IconButton, IconButtonProps, styled, Typography, TypographyProps } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'

interface IProps extends ButtonProps {
  disabledIcon?: boolean
}

export const UIBtnBack: FC<IProps> = ({ children, disabledIcon, ...props }) => {
  const renderContent = () => {
    if (!children || typeof children == 'string') {
      return (
        <Typography variant='caption' sx={{ fontWeight: 600, fontSize: '13px' }}>
          {children || 'back'}
        </Typography>
      )
    }
    return children
  }

  return (
    <ButtonBack
      size='small'
      startIcon={disabledIcon !== true ? <ArrowBackIosNewIcon fontSize='small' sx={{ width: '0.9em', height: '0.9em' }} /> : undefined}
      endIcon={<TextEsc>Esc</TextEsc>}
      {...props}
    >
      {renderContent()}
    </ButtonBack>
  )
}

const ButtonBack = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none!important',
  flex: '0 0 auto',
  color: '#818181',
  transition: 'linear 0.2s',
  cursor: 'pointer',
  marginTop: 0,
  paddingRight: '14px',
  paddingLeft: '8px',
  '&:hover': { color: '#006bd6' },
  '&:hover span.MuiTypography-caption': { borderColor: '#006bd6' }
})

const TextEsc = styled(({ children, ...p }: TypographyProps) => (
  <Typography component='span' variant='caption' {...p}>
    {children}
  </Typography>
))({
  fontFamily: `Roboto`,
  transition: 'linear 0.2s',
  display: 'inline-block',
  border: '1px solid #818181',
  borderRadius: '5px',
  padding: '0 2px',
  fontSize: '10px!important',
  lineHeight: 1.5,
  fontWeight: 600,
  marginTop: '-1px',
  marginLeft: '3px'
})

export const UIBtnClose = styled(({ children, ...props }: IconButtonProps) => <IconButton {...props}>{children ?? <CloseIcon />}</IconButton>)({
  flex: '0 0 auto',
  color: '#3c3c3c',
  '& svg': { transition: 'all 0.2s' },
  '&:hover svg': { color: '#ff200c' }
})
